import { render, staticRenderFns } from "./CustomersTable.vue?vue&type=template&id=388c4f5c"
import script from "./CustomersTable.vue?vue&type=script&lang=js"
export * from "./CustomersTable.vue?vue&type=script&lang=js"
import style0 from "./CustomersTable.vue?vue&type=style&index=0&id=388c4f5c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388c4f5c')) {
      api.createRecord('388c4f5c', component.options)
    } else {
      api.reload('388c4f5c', component.options)
    }
    module.hot.accept("./CustomersTable.vue?vue&type=template&id=388c4f5c", function () {
      api.rerender('388c4f5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/plantNursery/customers/components/tables/CustomersTable.vue"
export default component.exports